export default __webpack_public_path__ + "static/earth-drilling-logo-94389756c59b1f5c92da870d5cc4b0a1.png";